import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

export default function NotificationBell() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [d, setD] = useState({ items: [], unread: 0 });
  useEffect(() => {
    if (!user) return;
    const load = () => document.visibilityState === "visible" && api.get("/notifications").then((r) => setD(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
  }, [user]);
  if (!user) return null;
  const open = (v) => { if (v && d.unread) api.post("/notifications/read").then(() => setD((x) => ({ ...x, unread: 0 }))); };
  return (
    <Popover onOpenChange={open}>
      <PopoverTrigger data-testid="nav-notifications" aria-label="Notifications" className="relative p-2 rounded-full hover:bg-white/10 transition-colors">
        <Bell size={18} />
        {d.unread > 0 && <span data-testid="nav-notifications-count" className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-[#ff5500] text-[10px] font-bold grid place-items-center">{d.unread}</span>}
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 bg-[#12141c] border-white/10 p-2 max-h-96 overflow-y-auto" data-testid="notifications-panel">
        <p className="px-2 py-1 text-xs uppercase tracking-wider text-slate-500 flex items-center">Notifications<button data-testid="notifications-view-all" onClick={() => nav("/notifications")} className="ml-auto normal-case tracking-normal text-[#ff5500] font-semibold hover:underline">View all</button></p>
        {!d.items.length && <p className="px-2 py-6 text-sm text-slate-500 text-center">No notifications yet</p>}
        {d.items.map((n) => (
          <button key={n.id} data-testid="notification-item" onClick={() => nav(n.link || "/")} className={`w-full text-left rounded-xl px-3 py-2 text-sm hover:bg-white/5 ${n.read ? "text-slate-400" : "text-white"}`}>
            {!n.read && <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#ff5500] mr-2 align-middle" />}{n.text}
            <span className="block text-[10px] text-slate-500 mt-0.5">{new Date(n.at).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" })}</span>
          </button>
        ))}
      </PopoverContent>
    </Popover>
  );
}
